export class EstadoPlazaModel {

  id: number;
  nombre: string;

  constructor() {
    this.id = null;
    this.nombre = '';
  }
}
